<template>
  <div class="fill-requisites">
    <div class="pa-4">
      <v-alert
          v-if="isLoading"
          type="warning"
      >
        Проверка анкеты
      </v-alert>
      <v-alert
          v-if="message && !showForm"
          type="info"
      >
        {{ message }}
        <template #append>
          <v-btn
            color="secondary"
            @click="editForm"
          >Редактировать</v-btn>
        </template>
      </v-alert>
      <v-alert
          v-if="isFinished"
          type="success"
      >
        Анкета заполнена!
      </v-alert>
    </div>

    <v-form
        v-if="showForm && !isFinished && !isLoading"
        class="pa-4"
    >
      <v-row>
        <v-col
            v-for="field in fields"
            :key="field.model"
            cols="12"
            md="6"
        >
          <component
            :is="field.component"
            v-bind="field.props"
            v-model="form[field.model]"
          ></component>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-alert
              v-if="hasEmptyFields && showForm"
              type="warning"
          >
            Не все поля заполнены!
          </v-alert>

          <v-btn
              color="success"
              class="mr-4"
              :disabled="hasEmptyFields"
              @click="sendForm"
          >
            Отправить
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import {VFileInput, VTextField} from "vuetify/lib";
import moment from "moment";

export default {
  name: "fill-requisites",
  data() {
    return {
      contact: '',
      deal: '',
      message: '',
      showForm: false,
      isFinished: false,
      isLoadingReq: false,
      fields: [
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Фамилия',
            placeholder: '',

          },
          model: 'lastname',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Имя',
            placeholder: '',

          },
          model: 'firstname',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Отчество',
            placeholder: '',

          },
          model: 'mname',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Дата рождения',
            placeholder: '',
            type: 'date',

          },
          model: 'birthDate',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Место рождения',
            placeholder: '',

          },
          model: 'birthPlace',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Серия паспорта',
            placeholder: '',
          },
          mask: '####',
          model: 'docSerial',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Номер паспорта',
            placeholder: '',

          },
          model: 'docNum',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Дата выдачи',
            placeholder: '',
            type: 'date',
          },
          model: 'docDate',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Орган выдавший паспорт',
            placeholder: '',

          },
          model: 'docOrg',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Код-подразделения',
            placeholder: '',

          },
          model: 'docOrgCode',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Адрес регистрации',
            placeholder: '',

          },
          model: 'Address',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'ИНН',
            placeholder: '',

          },
          model: 'inn',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Наименование банка',
            placeholder: '',

          },
          model: 'BankName',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'БИК',
            placeholder: '',

          },
          model: 'BankBik',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Расчетный счет',
            placeholder: '',

          },
          model: 'BankAcc',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Кор. счет',
            placeholder: '',

          },
          model: 'BankAccCor',
          component: VTextField,
        },
        {
          props: {
            dense: true,
            outlined: true,
            label: 'Фото/скан СНИЛСа',
            placeholder: '',

          },
          model: 'snils',
          component: VFileInput,
        },
      ],
      form: {
        requisitesId: '',
        inn: '',
        lastname: '',
        firstname: '',
        mname: '',
        docSerial: '',
        docNum: '',
        docOrg: '',
        docOrgCode: '',
        docDate: '',
        birthDate: '',
        birthPlace: '',
        Address: '',
        BankName: '',
        BankBik: '',
        BankAcc: '',
        BankAccCor: '',
        snils: null,
      },
      requisites: null,
    }
  },
  computed: {
    isLoading() {
      return Boolean(this.contact
          && this.deal
          && !this.message
          && !this.showForm
      ) || this.isLoadingReq
    },
    hasEmptyFields() {
      return Object.entries(this.form).filter(([k, v]) => k !== 'requisitesId')
          .some(([k, v]) => !Boolean(v));
    }
  },
  created() {
    const { contact, deal } = this.$route.params;

    this.contact = contact;
    this.deal = deal;

    this.checkLink();
  },
  methods: {
    editForm() {
      this.showForm  = true;
    },
    async sendForm() {
      this.isLoadingReq = true;
      const { snils, ...form } = this.form;

      const fd = new FormData();
      fd.append('file', snils);
      fd.append('contactId', this.contact);
      fd.append('dealId', this.deal);

      Object.entries(form).forEach(([key, val]) => {
        fd.append(key, val);
      });

      const { data } = await this.$ax.post('v15/shopper/fill-form', fd);

      this.isFinished = data.ok;
      this.isLoadingReq = false;
    },
    async checkLink() {
      this.isLoadingReq = true;
      try {
        const { data: { ok, message, result } } = await this.$ax.get('v15/shopper/check-fill-link', {
          params: {
            contact: this.contact,
            deal: this.deal,
          }
        });

        if (result) {
          if (result.requisites) {
            [
              ['RQ_LAST_NAME', 'lastname'],
              ['RQ_FIRST_NAME', 'firstname'],
              ['RQ_SECOND_NAME', 'mname'],
              ['RQ_IDENT_DOC_DATE', 'docDate'],
              ['RQ_IDENT_DOC_DEP_CODE', 'docOrgCode'],
              ['RQ_IDENT_DOC_ISSUED_BY', 'docOrg'],
              ['RQ_IDENT_DOC_NUM', 'docNum'],
              ['RQ_IDENT_DOC_SER', 'docSerial'],
              ['RQ_INN', 'inn'],
              ['UF_RQ_DATEBIRTH', 'birthDate'],
              ['UF_RQ_BIRTHPLACE', 'birthPlace'],
              ['ID', 'requisitesId'],
            ].forEach(([rKey, fKey]) => {
              if ([
                'docDate',
                'birthDate',
              ].includes(fKey)) {
                this.form[fKey] = moment(result.requisites[rKey], 'DD.MM.YYYY').format('YYYY-MM-DD');
              } else {
                this.form[fKey] = result.requisites[rKey];
              }
            })
          }

          if (result.address) {
            [
                ['ADDRESS_1', 'Address']
            ].forEach(([rKey, fKey]) => {
              if ([].includes(fKey)) {
                this.form[fKey] = moment(result.address[rKey], 'DD.MM.YYYY').format('YYYY-MM-DD');
              } else {
                this.form[fKey] = result.address[rKey];
              }
            })
          }

          if (result.bank) {
            [
                ['RQ_BANK_NAME', 'BankName'],
                ['RQ_COR_ACC_NUM', 'BankAccCor'],
                ['RQ_ACC_NUM', 'BankAcc'],
                ['RQ_BANK_CODE', 'BankBik'],
            ].forEach(([rKey, fKey]) => {
              if ([].includes(fKey)) {
                this.form[fKey] = moment(result.bank[rKey], 'DD.MM.YYYY').format('YYYY-MM-DD');
              } else {
                this.form[fKey] = result.bank[rKey];
              }
            })
          }
        }

        this.showForm = ok;

        if (message) {
          this.message = message;
        }
      } catch (e) {
        console.log(e);
      }
      this.isLoadingReq = false;
    }
  }
}
</script>

<style>

</style>
